<div class="h2 content-title text-center p-3">Önkormányzat feladatai</div>

<div class=" my-3 col-lg-10 mx-auto mx-5">
  <div class="row mt-4">
    <div class="col-md-4">
      <p class=" h4 py-3  font-weight-bold content-title text-center">
        Az önkormányzat alapfeladatai
      </p>
      <p>
        Az önkormányzat köteles gondoskodni:<br />
        - az egészséges ivóvízellátásról<br />
        - az egészségügyi és szociális alapellátásról<br />
        - a közvilágításról<br />
        - a helyi közutak és köztemető fenntartásáról<br />
        - a nemzeti és etnikai kisebbségek jogainak érvényesítéséről
      </p>
    </div>
    <div class="col-md-4">
      <p class=" h4 py-3  font-weight-bold content-title text-center">
        A Polgármesteri Hivatal által ellátott alap- és főtevékenységek
      </p>
      <p>
        1. Az önkormányzati törvényben és egyéb jogszabályokban előírt ellátási
        kötelezettségek és hatósági feladatok ellátása.<br />
        2. A részben önálló intézmények gazdálkodási feladatainak ellátása<br />
        3. Az alább felsorolt szakfeladatok ellátása
      </p>
    </div>
    <div class="col-md-4">
      <p class=" h4 py-3  font-weight-bold content-title text-center">
        Önként vállalt feladatok
      </p>
      <p>
        Az önkormányzat szabadon vállalhatja közfeladat ellátását abban az
        esetben, ha<br />
        - ellátása nem sérti más települések érdekeit<br />
        - nem tartozik más szerv kizárólagos feladat- és hatáskörébe<br />
        - megvalósítása nem veszélyezteti a kötelezően előírt feladat- és
        hatáskörök ellátását<br />
        - ellátásához a szükséges feltételek fennállnak.
      </p>
      <p>
        A feladatok önkéntes vállalása előtt minden esetben előkészítő eljárást
        kell lefolytatni. Az előkészítő eljárás lefolytatásáról a polgármester
        gondoskodik. A közfeladat önkéntes felvállalását tartalmazó javaslat
        akkor terjeszthető a képviselő-testület elé, ha tartalmazza a
        megvalósításhoz szükséges költségvetési forrásokat. Az önként vállalt
        (többlet) feladatok tekintetében az éves költségvetésben - a fedezet
        biztosításával egyidejűleg - kell állást foglalni.
      </p>
    </div>
  </div>
</div>
